module.exports = __webpack_public_path__ + "check-contract@2x.22d29ed7e25720e898c4551731c8cdbb.png";